import React from 'react';
import { TrophyIcon } from '../icons/InterfaceIcons';

export const LeaderboardCard = () => {
    return (
        <div className="bg-brand-surface border border-brand-border rounded-xl p-6 h-full shadow-card">
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-xl text-brand-text-primary">Leaderboard</h3>
                <TrophyIcon className="w-6 h-6 text-brand-accent-amber" />
            </div>
            <div className="flex items-center justify-center h-full -mt-8">
                 <p className="text-sm text-brand-text-secondary">Leaderboard is coming soon!</p>
            </div>
        </div>
    );
};